{
  "version": 1,
  "asset_id": "ff651fc8-2737-4715-8b31-f8ce781e3b5a",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/ff651fc8-2737-4715-8b31-f8ce781e3b5a/opslag-ruimte-vakkundig.jpeg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/ff651fc8-2737-4715-8b31-f8ce781e3b5a/opslag-ruimte-vakkundig.jpeg",
  "original_filename": "opslag-ruimte-vakkundig.jpeg",
  "size": 344203,
  "content_type": "image/jpeg",
  "created_at": "2026-11-02T22:24:36Z"
}
